import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCCenLhXR7sTkfS2Lz79cFmwGxn7kokwhc",
  authDomain: "sauvie-e78b5.firebaseapp.com",
  projectId: "sauvie-e78b5",
  storageBucket: "sauvie-e78b5.firebasestorage.app",
  messagingSenderId: "414305061568",
  appId: "1:414305061568:web:8409cd0ed09985a0503b25"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
